import { ref } from 'vue';

const isDark = ref(false);

const appVariant = import.meta.env.VITE_APP_VARIANT;

// Initialize on load
if (typeof window !== 'undefined') {
  if (appVariant === 'appointment-manager') {
    const storedTheme = localStorage.getItem('theme');
    if (
      storedTheme === 'dark' ||
      (!storedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
      isDark.value = true;
      document.documentElement.classList.add('dark');
    } else {
      isDark.value = false;
      document.documentElement.classList.remove('dark');
    }
  } else {
    isDark.value = false;
    document.documentElement.classList.remove('dark');
  }
}

export function useDarkMode() {
  function toggleDarkMode() {
    isDark.value = !isDark.value;
    if (isDark.value) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }

  return {
    isDark,
    toggleDarkMode,
  };
}
